import React from "react";
import Helmet from "react-helmet";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import { compose } from "recompose";
import withLayout from "../../layout";
import withPageContext from "../../pageContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faStar, faCheck, faThumbsUp, faHandshake } from "@fortawesome/pro-regular-svg-icons"
import { faSlidersH } from "@fortawesome/pro-light-svg-icons"
import { faGem, faCheckCircle } from "@fortawesome/pro-solid-svg-icons"


import HeroDuctlessImage from "../../images/HeroDuctlessImage.jpeg"
import LGDuctlessImage from "../../images/LGPrestigeImage.png"
import LGGlossWhiteImage from "../../images/LGGlossWhiteImage.jpg"
import LGMirrorImage from "../../images/LGMirrorImage.jpg"
import LGCassetteImage from "../../images/LGCassetteImage.jpeg"
import LGMultiImage from "../../images/LGMultiImage.jpg"
import MoneyBagSImage from "../../images/MoneyBagSImage.png"
import MoneyBagLImage from "../../images/MoneyBagLImage.png"
import ApprovalSignSImage from "../../images/ApprovalSignSImage.png"
import ApprovalSignLImage from "../../images/ApprovalSignLImage.png"
import EvolutionSImage from "../../images/EvolutionSImage.png"
import EvolutionLImage from "../../images/EvolutionLImage.png"
import BulbSImage from "../../images/BulbSImage.png"
import BulbLImage from "../../images/BulbLImage.png"
import LGLogoImage from "../../images/LGLogoImage.png"
import LGWarrantyImage from "../../images/LGWarrantyImage.png"
import MoneyBillImage from "../../images/MoneyBillImage.png"
import MoneyBagImage from "../../images/MoneyBagImage.png"

import ModalPopPup from "../../components/modalPopPup"
// import SEO from "../components/seo"

const DuctlessHeatPump = ({ intl }) => (
    <React.Fragment>
        <Helmet>
            <title>{intl.formatMessage({ id: "ductless-heat-pump.title" })}</title>
        </Helmet>
        <div>

			<div className="heroImage" style={{ backgroundImage: `url(${HeroDuctlessImage})` }}>
  			<div className="wrap">
  				<div className="innerHeroImage">
  					<h1 itemprop="headline"><FormattedMessage id="ductless-heat-pump.maintext1" /></h1>
  				</div>
  			</div>
  		</div>


  		<div className="jumpMenu">
  			<div className="wrap">
  				<a href="#models" className="links">
						<i><FontAwesomeIcon icon={faStar} /></i>
            <FormattedMessage id="jump-menu.title1" />
  				</a>
  				<a href="#why-ductless" className="links">
  					<i><FontAwesomeIcon icon={faStar} /></i>
            <FormattedMessage id="jump-menu.title2" />
  				</a>
  				<a href="#why-lg" className="links">
  					<i><FontAwesomeIcon icon={faStar} /></i>
            <FormattedMessage id="jump-menu.title3" />
  				</a>
  				<a href="#payment-options" className="links">
  					<i><FontAwesomeIcon icon={faStar} /></i>
            <FormattedMessage id="jump-menu.title4" />
  				</a>
  			</div>
  		</div>




  		<div className="site-inner">
  			<div className="content-sidebar-wrap">

  				<main className="content" id="genesis-content">
  					<div className="greyBack" id="models">
  						<div className="wrap">

  							<div className="titleBox">
  								<h2><FormattedMessage id="models" /></h2>
  							</div>

  							<div className="modelsFlex">

									<div className="eachModel"><img src={LGDuctlessImage} alt=""/>
  									<div className="modelBox">
  										<h4><FormattedMessage id="model.title1" /></h4>
  										<p><FormattedMessage id="model.text1" /></p>
  									</div>
  								</div>

									<div className="eachModel"><img src={LGGlossWhiteImage} alt=""/>
  									<div className="modelBox">
                    <h4><FormattedMessage id="model.title2" /></h4>
                    <p><FormattedMessage id="model.text2" /></p>
  									</div>
  								</div>

									<div className="eachModel"><img src={LGMirrorImage} alt=""/>
  									<div className="modelBox">
                    <h4><FormattedMessage id="model.title3" /></h4>
                    <p><FormattedMessage id="model.text3" /></p>
  									</div>
  								</div>

									<div className="eachModel"><img src={LGCassetteImage} alt=""/>
  									<div className="modelBox">
                    <h4><FormattedMessage id="model.title4" /></h4>
                    <p><FormattedMessage id="model.text4" /></p>
  									</div>
  								</div>

									<div className="eachModel"><img src={LGMultiImage} alt=""/>
  									<div className="modelBox">
                    <h4><FormattedMessage id="model.title5" /></h4>
                    <p><FormattedMessage id="model.text5" /></p>
  									</div>
  								</div>

  							</div>
  						</div>
  					</div>



  					<div id="why-lg" className="benefits">
  						<div className="wrap">
  							<div className="benefitsDiv">
  								<div className="titleBox">
  									<h2><FormattedMessage id="why-ductless.maintitle" /></h2>
  								</div>
  								<div className="allBenefits">
  									<div className="theBenefit">
											<img className="hover" src={MoneyBagSImage} alt=""/>
											<img className="noHover" src={MoneyBagLImage} alt=""/>
  										<h3><FormattedMessage id="why-ductless.title1" /></h3>
  										<p><FormattedMessage id="why-ductless.text1" /></p>
  									</div>
  									<div className="theBenefit">
											<img className="hover" src={ApprovalSignSImage} alt=""/>
											<img className="noHover" src={ApprovalSignLImage} alt=""/>
                      <h3><FormattedMessage id="why-ductless.title2" /></h3>
  										<p><FormattedMessage id="why-ductless.text2" /></p>
  									</div>
  									<div className="theBenefit">
											<img className="hover" src={EvolutionSImage} alt=""/>
											<img className="noHover" src={EvolutionLImage} alt=""/>
                      <h3><FormattedMessage id="why-ductless.title3" /></h3>
  										<p><FormattedMessage id="why-ductless.text3" /></p>
  									</div>
  									<div className="theBenefit">
											<img className="hover" src={BulbSImage} alt=""/>
											<img className="noHover" src={BulbLImage} alt=""/>
                      <h3><FormattedMessage id="why-ductless.title4" /></h3>
  										<p><FormattedMessage id="why-ductless.text4" /></p>
  									</div>
  								</div>
  							</div>
  						</div>
  					</div>

            <div id="why-ductless">
              <div className="wrap">
                <div className="whyDuct">

                  <div className="ductContent">
                    <h2><FormattedMessage id="why-lg.maintitle" /></h2>
										<p><strong><span style={{ color: "#70c000" }}><i><FontAwesomeIcon icon={faCheck} /></i><FormattedMessage id="why-lg.title1" /></span></strong></p>
                    <p><FormattedMessage id="why-lg.text1" /></p>
										<p><strong><span style={{ color: "#70c000" }}><i><FontAwesomeIcon icon={faCheck} /></i><FormattedMessage id="why-lg.title2" /></span></strong></p>
                    <p><FormattedMessage id="why-lg.text2" /></p>
                  </div>

                  <div className="ductImg">
										<div><img src={LGLogoImage} alt=""/></div>
										<div><img src={LGWarrantyImage} alt=""/></div>
                  </div>
                </div>
              </div>
            </div>


  					<div className="wrap">
  						<div className="qualities">
  							<div className="titleBox">
  								<h2><FormattedMessage id="why-andmar.maintitle" /></h2>
  								<p><FormattedMessage id="why-andmar.text" /></p>
  							</div>
  							<div className="allQualities">
									<div className="theQuality"><i><FontAwesomeIcon icon={faSlidersH} /></i>
  									<h3><FormattedMessage id="attribute1.title" /></h3>
  									<p><FormattedMessage id="attribute1.text" /></p>
  								</div>
  								<div className="lineQualities"></div>
									<div className="theQuality"><i><FontAwesomeIcon icon={faGem} /></i>
                  <h3><FormattedMessage id="attribute2.title" /></h3>
                  <p><FormattedMessage id="attribute2.text" /></p>
  								</div>
  								<div className="lineQualities"></div>
									<div className="theQuality"><i><FontAwesomeIcon icon={faThumbsUp} /></i>
                  <h3><FormattedMessage id="attribute3.title" /></h3>
                  <p><FormattedMessage id="attribute3.text" /></p>
  								</div>
  								<div className="lineQualities"></div>
									<div className="theQuality"><i><FontAwesomeIcon icon={faHandshake} /></i>
                  <h3><FormattedMessage id="attribute4.title" /></h3>
                  <p><FormattedMessage id="attribute4.text" /></p>
  								</div>
  								<div className="lineQualities"></div>
  							</div>
  						</div>
  					</div>
  					<div className="greyBack" id="payment-options">
  						<div className="wrap">
  							<div className="titleBox">
  								<h2><FormattedMessage id="payment-options.title" /></h2>
  								<p><FormattedMessage id="payment-options.text" /></p>
  							</div>
  							<div className="productFlex">
  								<div className="eachP">
  									<div className="innerP">
  										<div className="productImg">
												<img src={MoneyBillImage} alt=""/></div>
  										<h3><FormattedMessage id="payment-option1.title" /></h3>
  										<div className="pricesPro">
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag1" /></div>
  												<div className="rightPrice"><FormattedMessage id="payment-option1.attributetext1" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option1.attributetag2" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option1.attributetext2" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option1.attributetag3" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option1.attributetext3" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option1.attributetag4" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option1.attributetext4" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option1.attributetag5" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option1.attributetext5" /></div>
  											</div>
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option1.attributetag6" /></div>
													<div className="rightPrice"><i><FontAwesomeIcon icon={faCheckCircle} /></i></div>
  											</div>
  										</div>
  									</div><a href="http://andmar.cloud" ><FormattedMessage id="payment-option1.cta-button" /></a>
  								</div>
  								<div className="eachP">
  									<div className="innerP">
  										<div className="productImg">
												<img src={MoneyBagImage} alt=""/>
                      </div>
  										<h3><FormattedMessage id="payment-option2.title" /></h3>
  										<div className="pricesPro">
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag1" /></div>
  												<div className="rightPrice"><FormattedMessage id="payment-option2.attributetext1" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option2.attributetag2" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option2.attributetext2" /></div>
  											</div>
  											<div className="eachPrice">
                        <div className="leftPrice"><FormattedMessage id="payment-option2.attributetag3" /></div>
                        <div className="rightPrice"><FormattedMessage id="payment-option2.attributetext3" /></div>
  											</div>
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag4" /></div>
  												<div className="rightPrice"><i><FontAwesomeIcon icon={faCheckCircle} /></i></div>
  											</div>
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag5" /></div>
  												<div className="rightPrice"><i><FontAwesomeIcon icon={faCheckCircle} /></i></div>
  											</div>
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag6" /></div>
  												<div className="rightPrice"><i><FontAwesomeIcon icon={faCheckCircle} /></i></div>
  											</div>
  											<div className="eachPrice">
  												<div className="leftPrice"><FormattedMessage id="payment-option2.attributetag7" /></div>
  												<div className="rightPrice"></div>
  											</div>
  										</div>
  									</div><a href="http://andmar.cloud" target=""><FormattedMessage id="payment-option2.cta-button" /></a>
  								</div>
  							</div>
  						</div>
  					</div>
  				</main>


  			</div>
  		</div>


 <ModalPopPup style={intl.formatMessage({ id: "modal-class" })}/>

        </div>
    </React.Fragment>
);

DuctlessHeatPump.propTypes = {
    intl: intlShape.isRequired
};

export default compose(
    withPageContext,
    withLayout,
    injectIntl
)(DuctlessHeatPump);
